import React from 'react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';

interface SparklineChartProps {
  data: any[];
}

export function SparklineChart({ data }: SparklineChartProps) {
  if (!data || data.length === 0) {
    return <div />;
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={data}>
        <Line
          type="monotone"
          dataKey={data[0]?.usuarios ? 'usuarios' : data[0]?.receita ? 'receita' : 'premium'}
          stroke="#b4a3ff"
          dot={false}
          strokeWidth={2}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
